import { Table, Select, Switch, Loader, Modal } from "@mantine/core";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { withTranslation } from "react-i18next";
import Button from "../../components/Button";
import CompleteProfile from "../../components/CompleteProfile";
import Page from "../../components/Page";
import { backendUrl } from "../../constants";
import JobCard from "../../pages/Search/JobCard";
import ApplicationModal from "./ApplicationModal";
import "./styles.css";

const Index = () => {
  const id = JSON.parse(localStorage.getItem("userData")).id;
  const [tableData, setTableData] = useState([]);
  const [apps, setApps] = useState([]);
  const [viewJobId, setViewJobId] = useState("");
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const jobStatus = [
    { value: "all", label: "All Jobs" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "expired", label: "Expired" },
  ];


  //Get Data
  useEffect(() => {
    setLoading(true);
    setTableData([]);
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}job/listEmployeeJobs/${id}/${filter}/1/100`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            key: obj._id,
            title: obj.jobTitle,
            companyId: obj.createdBy._id,
            logo: obj.attachedFiles[0]?.filePath,
            company: obj.createdBy.companyProfileInfo[0].companyName,
            description: obj.jobDescription,
            location: obj.empLocation?.city,
            date: obj.createdDate,
            remote: obj.remotely,
            state: obj.state,
          };
          setTableData((emp) => [...emp, a]);
        });
        setLoading(false);
      })

      .catch((err) => console.error(err));
  }, [filter, id]);

  //aaplications
  useEffect(() => {
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify({ createdBy: id }),
    };

    fetch(`${backendUrl}job/getAllApplied`, options)
      .then((response) => response.json())
      .then((response) => {
        setApps(response.data);
      })
      .catch((err) => console.error(err));
  }, [id]);

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="e-dashboard">
        <div className="dash-a">
          <h2 className="text-dark">My Jobs</h2>
          <Select
            defaultValue={"all"}
            data={jobStatus}
            style={{ width: "200px" }}
            maxDropdownHeight={400}
            onChange={(v) => setFilter(v)}
          />
          <div className="">
            {loading ? (
              <Loader
                size="xl"
                color="red"
                style={{ margin: "center", width: "100%" }}
              />
            ) : (
              tableData?.map((obj, key) => {
                return (
                  <div className="d-flex align-items-center gap-2">
                    <div className="col-md-9">
                      <JobCard
                        data={obj}
                        key={key}
                        setOpened={setShowModal}
                        setViewJobId={setViewJobId}
                        displaySwitch={true}
                        // className="col-md-10"
                      />
                    </div>
                  
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div className="dash-b">
          <CompleteProfile />
        </div>
      </div>
      <ApplicationModal opened={showModal} setOpened={setShowModal} apps={apps} viewJobId={viewJobId}/>
    </Page>
  );
};

export default withTranslation()(Index);
